const Height = props => {
    return <div className="container fluid py-2" id="height">

        <div className="container fluid">
            <p className="text xl"><a href="#height" className="link">&#128279;</a> Height</p>
            <p className="text md">
                Height is defined by <code>vh</code> CSS measurement unit, this category is mostly used for
            development.
        </p>
        </div>

        <div className="spacer md"></div>

        <div className="row align-items-center">
            <div className="col md-III">

                <div className="container md">
                    <div className="table" padding="1" cell-spacing="1" cell-border="1" table-striped="true">
                        <table>
                            <thead>
                                <tr>
                                    <th>Class</th>
                                    <th>Description</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <code>.h25, .h50, .h75, .h100</code>
                                    </td>
                                    <td>Sets the height of an element</td>
                                    <td>

                                        <div className="form-item sm">
                                            <label>Change the height of the element</label>
                                            <select onChange={(e) => props.helper('height-display', '', `border-dark`, e)}>
                                                <option value="h25">.h25</option>
                                                <option value="h50">.h50</option>
                                                <option value="h75">.h75</option>
                                                <option value="h100">.h100</option>
                                            </select>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <code>.min-h25, .min-h50, .min-h75, .min-h100</code>
                                    </td>
                                    <td>Sets the minimum height of an element, height will be auto</td>
                                    <td>

                                        <div className="form-item sm">
                                            <label>Change the height of the element</label>
                                            <select onChange={(e) => props.helper('height-display', '', `border-dark`, e)}>
                                                <option value="min-h25">.min-h25</option>
                                                <option value="min-h50">.min-h50</option>
                                                <option value="min-h75">.min-h75</option>
                                                <option value="min-h100">.min-h100</option>
                                            </select>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
            <div className="col md-III">

                <div className="container sm">
                    <div className="border-dark" id="height-display"></div>
                </div>

            </div>
        </div>

    </div>
}

export default Height